import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import {
	Alert,
	CircularProgress,
	Divider,
	Modal,
	TableHead,
} from "@mui/material";
import IconModal from "../../components/IconModal/IconModal";
import fontIcons from "../../assets/font-glyphs/icons.json";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
	alert: {
		cursor: "pointer",
		"& *": {
			cursor: "pointer",
		},
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	},
});

export default function Pages({ drawerWidth, setRun, goToHome, setGoToHome }) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({});
	const [selectedPage, setSelectedPage] = useState({});
	const [showIconMenu, setShowIconMenu] = useState(false);
	const [enableSupercategories, setEnableSuperCategories] = useState(true);
	const [showEnableSupercategoriesModal, setShowEnableSupercategoriesModal] =
		useState(false);

	const [showCategoriesModal, setShowCategoriesModal] = useState(false);

	const { user } = useContext(UserContext);
	const { t } = useTranslation();
	const alert = useAlert();
	const navigate = useNavigate();
	const classes = useStyles();
	//pages ecommerce
	/*const [pages, setPages] = useState([
		{
			id: 1,
			type: "Home",
			name: "Home",
			iconType: "MaterialIcons",
			iconName: "home",
			visible: true,
			order: 1,
		},
		{
			id: 2,
			type: "Search",
			name: "Search",
			iconType: "MaterialIcons",
			iconName: "search",
			visible: true,
			order: 2,
		},
		{
			id: 3,
			type: "Categories",
			name: "Categories",
			iconType: "MaterialIcons",
			iconName: "category",
			visible: true,
			order: 3,
		},
		{
			id: 4,
			type: "Cart",
			name: "Cart",
			iconType: "MaterialIcons",
			iconName: "shopping-cart",
			visible: true,
			order: 4,
		},
		{
			id: 5,
			type: "Favorites",
			name: "Favorites",
			iconType: "MaterialIcons",
			iconName: "star",
			visible: true,
			order: 5,
		},
		{
			id: 6,
			type: "News",
			name: "News",
			iconType: "MaterialIcons",
			iconName: "article",
			visible: true,
			order: 6,
		},
		{
			id: 7,
			type: "Contact",
			name: "Contact",
			iconType: "MaterialIcons",
			iconName: "email",
			visible: true,
			order: 7,
		},
		{
			id: 8,
			type: "Account",
			name: "Account",
			iconType: "MaterialIcons",
			iconName: "face",
			visible: true,
			order: 8,
		},
	]);*/

	//pages service
	const [pages, setPages] = useState([
		{
			id: 1,
			type: "Home",
			name: "Home",
			iconType: "MaterialIcons",
			iconName: "home",
			visible: true,
			order: 1,
		},
		{
			id: 3,
			type: "CategoriesServices",
			name: "Categories",
			iconType: "MaterialIcons",
			iconName: "category",
			visible: true,
			order: 3,
		},
		{
			id: 6,
			type: "News",
			name: "News",
			iconType: "MaterialIcons",
			iconName: "article",
			visible: true,
			order: 6,
		},
		{
			id: 7,
			type: "Contact",
			name: "Contact",
			iconType: "MaterialIcons",
			iconName: "email",
			visible: true,
			order: 7,
		},
		{
			id: 8,
			type: "Account",
			name: "Account",
			iconType: "MaterialIcons",
			iconName: "face",
			visible: true,
			order: 8,
		},
	]);

	const Icon = React.memo(({ family, name, ...props }) => (
		<span
			style={{
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));

	useEffect(() => {
		setRun(true);
	}, [setRun]);

	useEffect(() => {
		if (goToHome) {
			setGoToHome(false);
			navigate("/home");
		}
	}, [goToHome, setGoToHome, navigate]);

	const savePagesData = useCallback(async () => {
		setLoading(true);
		if (
			pages.filter((page) => page.visible).length > 5 &&
			data.navigationType === "Tab Bar"
		) {
			alert.show(t("pages.error"), { type: "error" });
		} else {
			try {
				await axios.post(
					ADMIN_URL + "creators",
					{
						...{ data },
						creatorPages: [...pages],
					},
					{
						headers: { authorization: localStorage.getItem("token") },
					}
				);
				alert.show(t("general.success"), { type: "success" });
			} catch (error) {
				console.log(error);
			}
		}
		setLoading(false);
	}, [pages, data, alert, t]);

	useEffect(() => {
		const getPagesData = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "creators", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setData({ ...res.data });

				let creatorPages =
					res.data.creatorPages.length > 0
						? [...res.data.creatorPages]
						: [...pages];

				if (res.data.app.appType !== "Ecommerce") {
					creatorPages = creatorPages.filter(
						(p) => p.type !== "Supercategories"
					);
				}

				setPages(creatorPages);
				setEnableSuperCategories(res.data.enableSupercategories);
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};

		getPagesData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setPage = (page) => {
		let auxPages = [...pages];
		let auxPage = auxPages.find((p) => p.id === page.id);
		auxPage.iconType = page.iconType;
		auxPage.iconName = page.iconName;
		auxPage.visible = page.visible;
		auxPage.name = page.name;
		auxPage.order = page.order;
		setPages(auxPages);
	};

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
				}}
			>
				<Toolbar />
				<Alert
					severity="info"
					sx={{
						marginBottom: 2,
					}}
					className={classes.alert}
					onClick={() => {
						navigate("/navigation");
					}}
				>
					{t("pages.info")}
				</Alert>
				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									minHeight: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px 20px",
								}}
								color="text.secondary"
								gutterBottom
							>
								{t("pages.title")}
							</Typography>

							<TableContainer component={Paper} sx={{ boxShadow: "none" }}>
								<Table
									sx={{ minWidth: { xs: "auto", sm: 650 } }}
									aria-label="simple table"
								>
									<TableHead
										sx={{ display: { xs: "none", sm: "table-header-group" } }}
									>
										<TableRow>
											<TableCell>{t("pages.type")}</TableCell>
											<TableCell align="left">{t("pages.name")}</TableCell>
											<TableCell align="left">{t("pages.icon")}</TableCell>
											<TableCell align="left">{t("pages.order")}</TableCell>
											<TableCell align="left">
												{t("pages.visibility")}
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{pages
											.sort((a, b) => a - b)
											.map((row, index) => (
												<TableRow
													key={row.id}
													sx={{
														opacity: row.visible ? 1.0 : 0.4,
														"&:last-child td, &:last-child th": { border: 0 },
														display: { xs: "flex", sm: "table-row" },
														flexWrap: "wrap",
														boxShadow: {
															xs: "0 0 1px rgba(0,0,0,0.4)",
															sm: "none",
														},
														width: { xs: "calc(100vw - 124px)", sm: "100%" },
														margin: { xs: 2, sm: 0 },
														marginBottom: { xs: 4, sm: 0 },
														borderRadius: { xs: 2, sm: 0 },
													}}
												>
													<TableCell
														component="th"
														scope="row"
														sx={{ width: { xs: "100%", sm: "auto" } }}
													>
														<Typography
															sx={{
																display: { xs: "block", sm: "none" },
																fontWeight: "bold",
															}}
														>
															{t("pages.type")}
														</Typography>
														{t(`menu.${row.type.toLowerCase()}`)}
													</TableCell>
													<TableCell
														align="left"
														sx={{ width: { xs: "100%", sm: "auto" } }}
													>
														<Typography
															sx={{
																display: { xs: "block", sm: "none" },
																fontWeight: "bold",
															}}
														>
															{t("pages.name")}
														</Typography>
														<TextField
															fullWidth
															variant="outlined"
															placeholder={"E.g." + row.name}
															value={row.name}
															onChange={(e) => {
																setPage({ ...row, name: e.target.value });
															}}
															disabled={
																!row.visible ||
																[
																	"building",
																	"built",

																	"publishing",
																	"published",
																	"inviting",
																].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)
															}
														/>
													</TableCell>
													<TableCell
														align="left"
														sx={{ width: { xs: "100%", sm: "auto" } }}
													>
														<Typography
															sx={{
																display: { xs: "block", sm: "none" },
																fontWeight: "bold",
															}}
														>
															{t("pages.icon")}
														</Typography>
														<IconButton
															onClick={() => {
																setSelectedPage(row);
																setShowIconMenu(true);
															}}
															disabled={
																!row.visible ||
																[
																	"building",
																	"built",

																	"publishing",
																	"published",
																	"inviting",
																].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)
															}
														>
															<Icon family={row.iconType} name={row.iconName} />
															{/*React.createElement(
															getIcon(row.iconType, row.iconName)
														)*/}
														</IconButton>
													</TableCell>
													<TableCell
														align="left"
														sx={{ width: { xs: "100%", sm: "auto" } }}
													>
														<Typography
															sx={{
																display: { xs: "block", sm: "none" },
																fontWeight: "bold",
															}}
														>
															{t("pages.order")}
														</Typography>
														<TextField
															fullWidth
															variant="outlined"
															placeholder={1}
															value={row.order}
															type="number"
															max={10}
															min={1}
															pattern="\d*"
															sx={{ width: 60 }}
															onChange={(e) => {
																setPage({ ...row, order: e.target.value });
															}}
															disabled={
																!row.visible ||
																[
																	"building",
																	"built",

																	"publishing",
																	"published",
																	"inviting",
																].find(
																	(status) =>
																		status ===
																		(user.app.appStatuses.length === 0
																			? ""
																			: user.app.appStatuses.length > 0 &&
																			  user.app.appStatuses[0].status)
																)
															}
														/>
													</TableCell>
													<TableCell
														align="left"
														sx={{ width: { xs: "100%", sm: "auto" } }}
													>
														<Typography
															sx={{
																display: { xs: "block", sm: "none" },
																fontWeight: "bold",
															}}
														>
															{t("pages.visibility")}
														</Typography>
														<FormGroup>
															<FormControlLabel
																control={
																	<Checkbox
																		checked={row.visible}
																		style={{ color: "#43BD98" }}
																		onChange={(e) => {
																			if (row.type === "Supercategories") {
																				if (!enableSupercategories) {
																					// If supercategories are disabled, show modal to enable them
																					setShowEnableSupercategoriesModal(
																						true
																					);
																				} else {
																					// Supercategories are enabled, handle "Categories" visibility
																					const categoryPage = pages.find(
																						(page) => page.type === "Categories"
																					);

																					if (
																						categoryPage &&
																						categoryPage.visible
																					) {
																						// If a "Categories" page is found and is visible, deselect it
																						setPage({
																							...categoryPage,
																							visible: false,
																						});
																					}

																					// Now set the visibility of the supercategories page as needed
																					setPage({
																						...row,
																						visible: e.target.checked,
																					});
																				}
																			} else if (row.type === "Categories") {
																				// Revisa si las supercategorias están habilitadas y se intenta alternar "Categories"

																				if (enableSupercategories) {
																					e.preventDefault(); // Evita que el checkbox cambie de estado
																					setShowCategoriesModal(true);
																				} else {
																					// Si las supercategorias no están visibles o habilitadas, permite el cambio normal
																					setPage({
																						...row,
																						visible: e.target.checked,
																					});
																				}
																			} else {
																				// For other types, just toggle the visibility as before
																				setPage({
																					...row,
																					visible: e.target.checked,
																				});
																			}
																		}}
																		id={index === 0 ? "pages-visible" : ""}
																		disabled={
																			[
																				"building",
																				"built",
																				"publishing",
																				"published",
																				"inviting",
																			].find(
																				(status) =>
																					status ===
																					(user.app.appStatuses.length === 0
																						? ""
																						: user.app.appStatuses.length > 0 &&
																						  user.app.appStatuses[0].status)
																			) ||
																			row.type === "Account" ||
																			row.type === "Cart"
																		}
																	/>
																}
																label={t("pages.visible")}
															/>
														</FormGroup>
													</TableCell>
												</TableRow>
											))}
									</TableBody>
								</Table>
							</TableContainer>
						</CardContent>
						{!["inviting", "building", "built", "publishing", "published"].find(
							(status) =>
								status ===
								(user.app.appStatuses.length === 0
									? ""
									: user.app.appStatuses.length > 0 &&
									  user.app.appStatuses[0].status)
						) && (
							<CardActions sx={{ justifyContent: "right" }}>
								<Button
									variant="contained"
									size="small"
									onClick={savePagesData}
									disabled={loading}
								>
									{loading ? <CircularProgress size={12} /> : t("general.save")}
								</Button>
							</CardActions>
						)}
						<IconModal
							showIconMenu={showIconMenu}
							setShowIconMenu={setShowIconMenu}
							page={selectedPage}
							setPage={setPage}
						></IconModal>
					</>
				</Card>
			</Box>
			<div>
				<Modal
					open={showEnableSupercategoriesModal}
					onClose={() => {
						setShowEnableSupercategoriesModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("supercategories.modalTitle")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>

						<Typography
							id="modal-modal-title"
							variant="body1"
							component="p"
							sx={{ marginTop: 4 }}
						>
							{t("supercategories.modalDescription")}
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								marginTop: 4,
							}}
						>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="contained"
								onClick={() => {
									navigate("/supercategories");
									setShowEnableSupercategoriesModal(false);
								}}
								size="medium"
							>
								{t("supercategories.modalButton")}
							</Button>
						</Box>
					</Box>
				</Modal>
			</div>
			<div>
				<Modal
					open={showCategoriesModal}
					onClose={() => {
						setShowCategoriesModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("supercategories.modalCategoryTitle")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>

						<Typography
							id="modal-modal-title"
							variant="body1"
							component="p"
							sx={{ marginTop: 4 }}
						>
							{t("supercategories.modalCategoryDescription")}
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								marginTop: 4,
							}}
						>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="outlined"
								onClick={() => {
									setShowCategoriesModal(false);
								}}
								size="medium"
							>
								{t("supercategories.modalCategoryButton2")}
							</Button>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="contained"
								onClick={() => {
									navigate("/supercategories");
									setShowCategoriesModal(false);
								}}
								size="medium"
							>
								{t("supercategories.modalCategoryButton")}
							</Button>
						</Box>
					</Box>
				</Modal>
			</div>
		</>
	);
}
